<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 40vw">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title">Discharge Patient</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <form @submit.prevent="submitDischarge">
          <div class="row mb-3">
            <div class="col-md-6">
              <label>Discharge Date:</label>
              <input
                type="date"
                v-model="form.discharge_date"
                class="form-control"
                required
              />
            </div>
            <div class="col-md-6">
              <label>Doctor:</label>
              <input
                type="text"
                v-model="form.doctor_name"
                class="form-control"
                placeholder="Doctor's name"
                required
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-12">
              <label>Condition on Discharge:</label>
              <select v-model="form.condition" class="form-control" required>
                <option value="" disabled>Select condition</option>
                <option value="Stable">Stable</option>
                <option value="Improved">Improved</option>
                <option value="Referred">Referred</option>
                <option value="Deceased">Deceased</option>
              </select>
            </div>
          </div>

          <!-- ✅ Added Next Visit Datetime -->
          <div class="row mb-3">
            <div class="col-md-12">
              <label>Next Visit (Optional):</label>
              <input
                type="datetime-local"
                v-model="form.next_visit_datetime"
                class="form-control"
                placeholder="Select next visit date and time"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-12">
              <label>Discharge Summary / Notes:</label>
              <textarea
                v-model="form.notes"
                class="form-control"
                rows="4"
                placeholder="Write discharge summary..."
                required
              ></textarea>
            </div>
          </div>
        </form>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" @click="submitDischarge">
          Confirm Discharge
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "DischargePatientModal",
  props: {
    patient: {
      type: Object,
      required: true,
    },
    visit_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      form: {
        discharge_date: new Date().toISOString().slice(0, 10),
        doctor_name: "",
        condition: "",
        notes: "",
        next_visit_datetime: "", // ✅ new field
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-discharge-modal");
    },
    async submitDischarge() {
      // this.closeModal();
      // Call the API function to discharge th
      const url = "end_visit/" + this.visit_id;
      await generalApiRequest(
        url,
        "GET",
        {
          ...this.form,
          visit_id: this.visit_id,
        },
        1
      );
      // Display a success message or update the UI

      alert("Patient successfully discharged!");
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.mmodal-content {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-footer {
  border-top: 1px solid #ddd;
  justify-content: flex-end;
}

.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
